<template>
  <transition name="school-loading-fade">
    <div v-if="visible" class="school-loading-overlay">
      <div class="school-loading-inner">
        <svg
          class="school-loading-svg"
          viewBox="0 0 48 48"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            class="school-loading-track"
            cx="24"
            cy="24"
            r="20"
            fill="none"
            stroke-width="3"
          />
          <circle
            class="school-loading-arc"
            cx="24"
            cy="24"
            r="20"
            fill="none"
            stroke-width="3"
            stroke-linecap="round"
          />
        </svg>
        <p class="school-loading-text">{{ text }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * @file SchoolLoading.vue
 * @description 学校模块通用精美加载遮罩层组件，提供旋转加载动画和提示文案
 */
export default {
  name: "SchoolLoading",
  props: {
    /**
     * 控制加载动画的显示与隐藏
     * @type {Boolean}
     */
    visible: {
      type: Boolean,
      default: false,
    },
    /**
     * 加载时显示的提示文本
     * @type {String}
     */
    text: {
      type: String,
      default: "加载中",
    },
  },
};
</script>

<style lang="less" scoped>
.school-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
}

.school-loading-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.school-loading-svg {
  width: 40px;
  height: 40px;
  animation: rotate 2s linear infinite;
}

.school-loading-track {
  stroke: rgba(0, 216, 195, 0.1);
}

.school-loading-arc {
  stroke: #00d8c3;
  animation: dash 1.5s ease-in-out infinite;
}

.school-loading-text {
  font-size: 13px;
  color: #00d8c3;
  font-weight: 500;
  margin: 0;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

.school-loading-fade-enter-active,
.school-loading-fade-leave-active {
  transition: opacity 0.25s ease;
}

.school-loading-fade-enter,
.school-loading-fade-leave-to {
  opacity: 0;
}
</style>
